export enum TenantName {
    stranaidea = 'stranaidea',
}
